/**
 * Loading and unloading confirmations are the steps where the driver app
 * forces photos of the goods; a dispatcher acting on the driver's behalf has
 * to attach them too, or the order ends up with no proof at all.
 */
export const isMissingRequiredDocuments = (
	step: { requiresDetails?: boolean } | null | undefined,
	filesCount: number,
): boolean => !!step?.requiresDetails && filesCount === 0;

export const WEIGHT_DIFFERENCE_TOLERANCE_PERCENT = 5;

export const getWeightDifferencePercent = (
	weight: number,
	orderedQuantity: number,
): number | null => {
	if (!Number.isFinite(weight) || weight <= 0 || !orderedQuantity) return null;
	return parseFloat(
		(((weight - orderedQuantity) / orderedQuantity) * 100).toFixed(2),
	);
};
